/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedRefineMenuSearchResults_facetSearch$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedRefineMenuTypeahead_viewer$ref: FragmentReference;
export type SbSharedRefineMenuTypeahead_viewer = {|
  +facetSearch?: ?{|
    +$fragmentRefs: SbSharedRefineMenuSearchResults_facetSearch$ref
  |},
  +$refType: SbSharedRefineMenuTypeahead_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuTypeahead_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "searchString",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "facetName",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "hasQuery",
      "type": "Boolean",
      "defaultValue": false
    },
    {
      "kind": "RootArgument",
      "name": "uriRef",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasQuery",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "facetSearch",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "facetName",
              "variableName": "facetName",
              "type": "String"
            },
            {
              "kind": "Literal",
              "name": "first",
              "value": 5,
              "type": "Int"
            },
            {
              "kind": "Literal",
              "name": "page",
              "value": 1,
              "type": "Int"
            },
            {
              "kind": "Variable",
              "name": "searchString",
              "variableName": "searchString",
              "type": "String"
            },
            {
              "kind": "Variable",
              "name": "uriRef",
              "variableName": "uriRef",
              "type": "String"
            }
          ],
          "concreteType": "FacetsQueryConnection",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "SbSharedRefineMenuSearchResults_facetSearch",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '4133a05b90cbaad2eea13ab86c2311a6';
module.exports = node;
